import { type CreateOrUpdateTagModel } from '@/shared/api'

import type { TagFormModel } from '..'

export function getTagSubmitRequestByFormValues(
  values: TagFormModel,
): CreateOrUpdateTagModel {
  return {
    name: values.name,
    contentType: values.contentType,
  }
}
